export default __webpack_public_path__ + "static/media/Payment.2583464b.png";